export default "__VITE_ASSET__Boy0eNqi__"